<template>
  <div id="main-survey-page">
    <b-row class="survey-header" no-gutters>
      <b-col>
        <div class="content-heading">
          <i class="ic-head-icon">
            <img src="@/assets/images/sidebar/survey.svg" alt="Survey Icon" />
          </i>
          <h4 class="head-title">Survey</h4>
          <i class="ic-tooltip" id="help"></i>
          <b-popover
            target="help"
            triggers="hover"
            content="Customize and publish your survey"
          >
          </b-popover>
          <div class="head-tabs">
            <b-nav tabs>
              <b-nav-item :to="{ path: '/survey' }"> Survey</b-nav-item>
            </b-nav>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="content-body survey-body">
      <b-row>
        <b-col md="4" class="mb-3 mb-md-0">
          <div class="filter-wrapper">
            <b-input-group prepend=" ">
              <b-input
                placeholder="Search"
                v-model="searchKey"
                @keyup.native="searchSurvey"
                maxlength="30"
              ></b-input>
            </b-input-group>
          </div>
        </b-col>
        <b-col md="4" offset-md="4" class="px-0 text-center text-md-right">
          <b-button
            variant="primary btn-add"
            @click="$root.$emit('bv::show::modal', 'create-survey-modal')"
          >
            Survey
          </b-button>
        </b-col>
      </b-row>
      <div class="mt-3">
        <div class="data-container">
          <b-table
            show-empty
            :items="surveyList"
            :empty-text="isLoading ? 'Loading data' : emptyText"
            :fields="tableFields"
            :current-page="surveys ? surveys.current_page : 1"
            responsive
          >
            <template slot="title" slot-scope="data">
              <div class="title text-truncate">
                {{ data.value }}
              </div>
            </template>
            <template slot="status" slot-scope="data">
              <div :class="data.value">
                {{ data.value }}
              </div>
            </template>
            <template slot="action" slot-scope="data">
              <b-row no-gutters>
                <b-col class="text-center action-col">
                  <i
                    :id="'popover-menu-edit-' + data.item.uuid"
                    class="action-button"
                    @click="showEditSurveyModal(data.item.uuid)"
                  >
                    <img
                      src="@/assets/images/icons/gear-black.svg"
                      alt="Edit Button"
                    />
                  </i>

                    <b-popover
                      :target="`popover-menu-edit-${data.item.uuid}`"
                      triggers="hover"
                      content="Edit Survey Details"
                      placement = "top"
                    >
                    </b-popover>
                </b-col>

                <b-col class="text-center action-col">
                  <i
                    :id="'popover-menu-edit-question-' + data.item.uuid"
                    class="action-button"
                    @click="
                      $router.push({
                        name: 'surveyQuestion',
                        params: { uuid: data.item.uuid },
                      })
                    "
                  >
                    <img
                      src="@/assets/images/icons/edit.svg"
                      alt="View Button"
                    />
                  </i>
                  <b-popover
                    :target="`popover-menu-edit-question-${data.item.uuid}`"
                    triggers="hover"
                    content="Edit Questions"
                    placement = "top"
                  >
                  </b-popover>
                </b-col>
                <b-col class="text-center action-col">
                  <i
                    :id="'popover-menu-duplicate-' + data.item.uuid"
                    class="action-button"
                    @click="showDuplicateSurveyModal(data.item.uuid)"
                  >
                    <img src="@/assets/images/icons/duplicate.svg" alt="Duplicate Button" class="action-button">
                  </i>
                  <b-popover
                    :target="`popover-menu-duplicate-${data.item.uuid}`"
                    triggers="hover"
                    content="Duplicate"
                    placement = "top"
                  >
                  </b-popover>
                </b-col>
                <b-col class="text-center action-col">
                  <i
                    :id="'popover-menu-share-' + data.item.uuid"
                    class="action-button"
                    @click="showShareSurveyModal(data.item.uuid)"
                  >
                    <img
                      src="@/assets/images/icons/share.svg"
                      alt="Share Button"
                    />
                  </i>
                  <b-popover
                    :target="`popover-menu-share-${data.item.uuid}`"
                    triggers="hover"
                    content="Share"
                    placement = "top"
                  >
                  </b-popover>
                </b-col>
                <b-col class="text-center action-col">
                  <i
                    :id="'popover-menu-export-' + data.item.uuid"
                    class="action-button"
                    @click="exportSurvey(data.item.uuid)"
                  >
                    <img
                      src="@/assets/images/icons/download.svg"
                      alt="Export Button"
                    />
                  </i>
                  <b-popover
                    :target="`popover-menu-export-${data.item.uuid}`"
                    triggers="hover"
                    content="Download Responses"
                    placement = "top"
                  >
                  </b-popover>
                </b-col>
                <b-col class="text-center dropdown-popover action-col">
                  <i
                      :id="'popover-menu-' + data.item.uuid"
                  >
                    <img src="@/assets/images/icons/pile-file.svg" alt="Dropdown" />
                  </i>
                    
                  <b-popover
                    :target="`popover-menu-${data.item.uuid}`"
                    triggers="hover blur"
                    placement="bottom"
                    class="px-0"
                    :container="`popover-menu-${data.item.uuid}`"
                  >
                    <div id="popover-menu-dropdown" class="popover-menu-item">
                      <div class="menu-item" @click="browseCSV(data.item.uuid)">
                        <b-form-file
                          v-model="importCsv"
                          hidden
                          accept=".csv"
                          :ref="'importCsv' + data.item.uuid">
                      </b-form-file>
                        Upload CSV Template
                      </div>
                      <hr class="divider" />
                      <a :href="generateCsvUrl(data.item.uuid)"><div class="menu-item" >Download CSV Template</div></a>
                    </div>
                  </b-popover>
                </b-col>
                <b-col class="text-center action-col">
                  <i
                    :id="'delete-' + data.item.uuid"
                    class="action-button"
                    @click="showDeleteSurveyModal(data.item.uuid)"
                  >
                    <img
                      src="@/assets/images/icons/delete-red.svg"
                      alt="Delete Button"
                    />
                  </i>

                  <b-popover
                    :target="'delete-' + data.item.uuid"
                    placement="top"
                    triggers="hover"
                    content="Delete"
                  >
                  </b-popover>
                </b-col>
              </b-row>
            </template>
          </b-table>
        </div>
      </div>
      <div>
        <b-row v-if="surveys">
          <b-col>
            <div class="mt-1">
              <span class="pagination-indicator">
                {{ pageFirstItem }} to {{ pageLastItem }} of
                {{ surveys["max_page"] }} pages
              </span>
              <b-pagination
                @change="getSurveyList"
                hide-goto-end-buttons
                align="left"
                size="md"
                :total-rows="surveys.total"
                :per-page="surveys.per_page"
                :limit="(surveys.total > 0) ? 3 : 1"
                class="custom-pagination-arrow-only mb-0 ml-2"
              >
              </b-pagination>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- MODALS START -->
    <CreateSurveyModal :isUcoin="isMerchantUcoin" />
    <ShareSurveyModal :uuid="uuid" />
    <EditSurveyModal :uuid="uuid" :isUcoin="isMerchantUcoin" @refresh-survey-list="getSurveyList" />
    <DuplicateSurveyModal :uuid="uuid" :isUcoin="isMerchantUcoin" @refresh-survey-list="getSurveyList" />
    <DeleteSurveyModal :uuid="uuid" @refresh-survey-list="getSurveyList" />
    <!-- MODALS END -->
  </div>
</template>

<script>
import CreateSurveyModal from "../modals/CreateSurveyModal";
import ShareSurveyModal from "../modals/ShareSurveyModal";
import EditSurveyModal from "../modals/EditSurveyModal";
import DuplicateSurveyModal from "../modals/DuplicateSurveyModal";
import DeleteSurveyModal from "../modals/DeleteSurveyModal";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
    name: "MainSurveyPage",
    data() {
        return {
            uuid: null,
            tableFields: [
                {
                    key: "title",
                    label: "Survey Title",
                    sortable: true
                },
                {
                    key: "questions_count",
                    label: "Questions",
                    sortable: true
                },
                {
                    key: "respondents",
                    label: "Responses",
                    sortable: true
                },
                {
                    key: "status",
                    label: "Status",
                    sortable: true
                },
                {
                    label: "Action",
                    sortable: true
                },
                "action"
            ],
            searchKey: "",
            surveyUuid: null,
            importCsv: null,
            env: process.env.VUE_APP_MODE,
            baseUrl: process.env.VUE_APP_API,
            isMerchantUcoin: false
        };
    },
    components: {
        CreateSurveyModal,
        ShareSurveyModal,
        EditSurveyModal,
        DuplicateSurveyModal,
        DeleteSurveyModal
    },
    methods: {
        ...mapActions("surveys", [
            "getSurveys",
            "getSurveyUrl",
            "getSurvey",
            "getSurveyExportFile",
            "isUcoin"
        ]),
        generateCsvUrl(uuid) {
            return (
                this.baseUrl +
                "survey-service/v2/api/cms/survey/template/download/" +
                uuid
            );
        },
        showShareSurveyModal(uuid) {
            this.getSurveyUrl({ uuid: uuid });
            this.$root.$emit("bv::show::modal", "share-survey-modal");
        },
        async showEditSurveyModal(uuid) {
            await this.getSurvey(uuid).then(() => {
                if (
                    this.errors === null ||
                    Object.keys(this.errors).length === 0
                ) {
                    this.$root.$emit("bv::show::modal", "edit-survey-modal");
                }
            });
        },
        async showDuplicateSurveyModal(uuid) {
            await this.getSurvey(uuid).then(() => {
                if (
                    this.errors === null ||
                    Object.keys(this.errors).length === 0
                ) {
                    this.$root.$emit("bv::show::modal", "duplicate-survey-modal");
                }
            });
        },
        showDeleteSurveyModal(uuid) {
            this.uuid = uuid;
            this.$root.$emit("bv::show::modal", "delete-survey-modal");
        },
        searchSurvey() {
            this.getSurveyList();
        },
        getSurveyList(page = 1) {
            this.getSurveys({
                page,
                params: {
                    search: {
                        keyword: this.searchKey
                    }
                }
            });
        },
        exportSurvey(uuid) {
            this.getSurveyExportFile(uuid).then(() => {
                if (this.surveyExportFile)
                    window.open(this.surveyExportFile, "_blank");
            });
        },
        browseCSV: function(uuid) {
            this.surveyUuid = uuid;
            console.log(this.surveyUuid);
            this.$refs["importCsv" + uuid].$el.children[0].click();
        },
        async checkUcoin() {
            this.isMerchantUcoin = await this.isUcoin();
            console.log('xxx');
        }
    },
    computed: {
        ...mapState("surveys", [
            "isLoading",
            "surveys",
            "selectedSurveyId",
            "surveyExportFile",
            "import"
        ]),
        ...mapGetters("surveys", ["errors"]),
        pageFirstItem() {
            return this.surveys["per_page"] * this.surveys["prev_page"] + 1;
        },
        pageLastItem() {
            return this.pageFirstItem > 0
                ? this.pageFirstItem + this.surveys.list.length - 1
                : 0;
        },
        surveyList() {
            const { list } = this.surveys;

            if (!list || (list && !list.length)) return [];

            return list.map(survey => {
                let status = "active";

                if (survey.expired) status = "expired";

                if (
                    !survey["is_enabled"] ||
                    this.$moment(survey["start_date"]).isAfter(this.$moment())
                )
                    status = "draft";

                return { ...survey, status };
            });
        },
        emptyText() {
            return `No Records Found${
                this.searchKey ? ` for "${this.searchKey}"` : ""
            }`;
        }
    },
    created() {
        this.getSurveyList();
        this.checkUcoin();
    },
    watch: {
        importCsv: function() {
            // let _this = this;

            this.$store.commit("surveys/setSurveyUuid", this.surveyUuid);
            this.$store.commit("surveys/setImportFile", this.importCsv);
            this.$store.dispatch("surveys/readImport");
        },
        import: function() {
            if (this.import) {
                // let _this = this;
                this.$store.dispatch("surveys/importSurvey");
            }
        }
    }
};
</script>
<style lang="scss">
.popover {
    background: #2f4858 !important;
    .popover-body {
        padding: 8px 16px !important;
        color: #ffffff !important;
        border-radius: 8px;
        font-size: 14px;
    }
}
.bs-popover-top .arrow::after,
.bs-popover-auto[x-placement^="top"] .arrow::after {
    border-top-color: #2f4858 !important;
}
/* Scoped Popover Styles */
.dropdown-popover .popover {
  background-color: transparent !important;                
  border-radius: 8px !important;
}

.dropdown-popover .popover-header,
.dropdown-popover .popover-body {
  background-color: #fff; 
}

.dropdown-popover .popover-menu-item {
  padding: 0;  
  color:#222d37;
}

.dropdown-popover .menu-item {
  padding: 8px 0px;
  min-width: 160px;
  text-align: left;
  cursor: pointer;
}

.dropdown-popover .divider {
  margin: 8px 0;
  border: 0;
  border-top: 1px solid #D8DCDE;
}

.dropdown-popover .popover-menu-item a {
  text-decoration: none; 
  color: inherit; 
  display: block;
}

.dropdown-popover .popover-menu-item a:focus,
.dropdown-popover .popover-menu-item a:active,
.dropdown-popover .popover-menu-item a:hover {
  color: inherit !important; 
  background: white !important; 
  outline: none !important;
}

.action-col {
  max-width: 48px;
}
</style>
